import * as React from "react";
import { NavLink } from "../FAQ/FAQ.styled";
import { MiniNav } from "../MoveIn.screen/MoveIn.styled";
import {
  Badge,
  EffortsCard,
  EffortsCardContainer,
  EffortsContainer,
  Header,
  InnerEffortsCards,
} from "./Efforts.styled";
import pipes from "../../assets/Bitmap.png";
import river from "../../assets/river.png";
import buildings from "../../assets/buildings.png";

import General from "../../stores/GeneralStore";
const Efforts = () => {
  return (
    <>
      <Header>
        <div style={{ width: "90%", margin: "0 auto" }}>
          <MiniNav>
            <NavLink to="">
              {General?.codeLabels["cm_home"]?.label !== undefined ? General?.codeLabels["cm_home"]?.label : " Home"}

            </NavLink>
            &nbsp;/&nbsp;
            <NavLink to="/about">

              {General?.codeLabels["cm_sustainability"]?.label !== undefined ? General?.codeLabels["cm_sustainability"]?.label : "Sustainability"}
            </NavLink>
            &nbsp;/&nbsp;
            <NavLink to="/">Our Sustainability Efforts</NavLink>
          </MiniNav>
          <h1>              {General?.codeLabels["cm_movein"]?.label !== undefined ? General?.codeLabels["cm_movein"]?.label : "Move In"}
            ( Tenancy Registration )</h1>
        </div>
        <Badge>
          Water is a very scarce resource. Finding and developing new sources
          can be expensive, difficult and very time consuming. There are a
          number of places where we get our water from, but they each have their
          own specific drawbacks, which means that we must constantly be aware
          of our water use and look for more innovative ways to increase our
          water supply.
        </Badge>
      </Header>
      <EffortsContainer>
        <h2>Rainwater Collection</h2>
        <EffortsCard>
          <img src={pipes} alt="pipes" />
          <p>
            Around the world, collecting and using rainwater via dams is a
            natural process that can provide a great source of water for our
            development and current use. In the UAE, this is no exception. There
            are over 30 dams located throughout the country that collect
            rainwater to be stored in reservoirs that can be used for irrigation
            purposes. <br />
            <br />
            Despite this, this is nowhere near a significant enough source for
            our overall water requirements for now and in the future as rainfall
            in the UAE is not frequent and on average is a very small amount.
          </p>
        </EffortsCard>
        <EffortsCardContainer>
          <InnerEffortsCards>
            <img src={river} alt="river" />
            <p>
              <p>
                <b>Groundwater</b>
              </p>
              Groundwater is exactly what it is, water that is located
              underground between rock sediments called aquifers. Over time,
              water enters the ground and is stored between soil pre spaces and
              gaps in rock formations. These massive, natural containers can –
              if used sparingly and efficiently – provide a significant amount
              of potable water to use in many ways. Aquifers are usually formed
              as part of a large system spanning a wide area and are found
              across the UAE and even cross-borders.
              <br />
              <br />
              However, overexploitation of these aquifers is becoming an
              increasing worry for countries around the world and especially
              ones here in the Middle East where water demand is outpacing
              supply in some areas. For example, in Abu Dhabi, groundwater
              sources are being used at more than 15 times the rate at which
              they can be replenished. This means that water that has been
              stored up to 10,000 years ago will have completely vanished.
              <br />
              <br />
              Even more worrying is what happens to the empty aquifers after the
              water is depleted. If they are not re-filled or filled in,
              saltwater intrusion can take place. This is where salt water from
              the coast gradually seeps in to the aquifers and makes the
              salinity levels of the sail increase. This can affect the local
              area and make it impossible for crops and other vegetation to grow
              properly.
            </p>
          </InnerEffortsCards>
          <InnerEffortsCards>
            <img src={buildings} alt="buildings" />
            <p>
              <p>
                <b>Desalinated Water</b>
              </p>
              Modern technology has allowed us to harness the abundance of
              perviously unusable water sources. Once though unusable, seawater
              can now be used as an effective source of potable and drinking
              water for the whole population to enjoy. In fact, 40% of the water
              used in the UAE comes from desalination. <br />
              <br />
              The process used desalination plants is called “Reverse Osmosis”,
              where a semi-permeable membrane is used to separate the salts from
              the water. Over the years, this has developed to a convenient way
              of creating large volumes of water over a period of time. <br />
              <br />
              Despite providing a great source of potable water, desalination
              comes with a hefty toll. The process can be very costly, not only
              in monetary terms but directly to the environment as well. The
              entire process is energy intensive, which is negatively
              contributing to our environment by adding excess carbon dioxide
              emissions to the atmosphere which in turn contributes to global
              warming. In addition to this, the natural ecosystem of the
              surrounding ocean is usually affected by such industrial water
              treatment.
            </p>
          </InnerEffortsCards>
        </EffortsCardContainer>
      </EffortsContainer>
    </>
  );
};

export default Efforts;
